import axios from 'axios'
import https from 'https'

export const httpServerClient = axios.create({
  httpsAgent: new https.Agent({
    rejectUnauthorized: false,
  }),
})
